import { render, staticRenderFns } from "./DebtForm.vue?vue&type=template&id=0319a31c&lang=pug&"
import script from "./DebtForm.vue?vue&type=script&lang=js&"
export * from "./DebtForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports